import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer'
import Home from './pages/Home';
import Servicios from './pages/Servicios'
import SobreMi from './pages/SobreMi'
import Redes from './pages/Redes' 
import ScrollToTop from './components/scrolltop';
function App() {
  return (
    <Router>
        <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Servicios />}/>
        <Route path="/contacto" element={<Redes />}/>
        <Route path="/sobremi" element={ <SobreMi />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
